import classNames from 'classnames';
import styles from './Badge.module.scss';

export interface BadgeProps {
	text: string;
	style?:
		| 'success'
		| 'successLight'
		| 'critical'
		| 'danger'
		| 'progress'
		| 'neutral'
		| 'info'
		| 'infoLight'
		| 'warningLight'
		| 'accent'
		| 'accentLight';
	indicator?: 'error' | 'idle' | 'offline' | 'paused' | 'running' | 'noConnectivity';
	size?: 'small';
}

export const Badge = ({ text, style, indicator = null, size }: BadgeProps) => {
	return (
		<span
			className={classNames(
				styles.Badge,
				style ? styles[`Badge___${style}`] : '',
				indicator ? styles.Badge___indicator : '',
				styles[`Badge___${size}`],
			)}
		>
			{indicator && <span className={classNames(styles.Badge_indicator, styles[`Badge_indicator___${indicator}`])} />}
			{text}
		</span>
	);
};
